import _objectSpread from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/leonidas/PlayReplay/playreplayTV/frontend/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import e from "react";
import t, { css as o, keyframes as r, ThemeProvider as a } from "styled-components";

function n(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}

function i() {
  return (i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

"undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;

function s(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var l = s(function (e) {
  !function () {
    var t = {}.hasOwnProperty;

    function o() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        var a = arguments[r];

        if (a) {
          var n = typeof a;
          if ("string" === n || "number" === n) e.push(a);else if (Array.isArray(a) && a.length) {
            var i = o.apply(null, a);
            i && e.push(i);
          } else if ("object" === n) for (var s in a) {
            t.call(a, s) && a[s] && e.push(s);
          }
        }
      }

      return e.join(" ");
    }

    e.exports ? (o.default = o, e.exports = o) : window.classNames = o;
  }();
}),
    d = s(function (e, t) {
  e.exports = function () {
    var e = function e(_e) {
      return function (e) {
        return !!e && "object" == typeof e;
      }(_e) && !function (e) {
        var o = Object.prototype.toString.call(e);
        return "[object RegExp]" === o || "[object Date]" === o || function (e) {
          return e.$$typeof === t;
        }(e);
      }(_e);
    },
        t = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

    function o(e, t) {
      return !1 !== t.clone && t.isMergeableObject(e) ? n((o = e, Array.isArray(o) ? [] : {}), e, t) : e;
      var o;
    }

    function r(e, t, r) {
      return e.concat(t).map(function (e) {
        return o(e, r);
      });
    }

    function a(e, t, r) {
      var a = {};
      return r.isMergeableObject(e) && Object.keys(e).forEach(function (t) {
        a[t] = o(e[t], r);
      }), Object.keys(t).forEach(function (i) {
        r.isMergeableObject(t[i]) && e[i] ? a[i] = function (e, t) {
          if (!t.customMerge) return n;
          var o = t.customMerge(e);
          return "function" == typeof o ? o : n;
        }(i, r)(e[i], t[i], r) : a[i] = o(t[i], r);
      }), a;
    }

    function n(t, n, i) {
      (i = i || {}).arrayMerge = i.arrayMerge || r, i.isMergeableObject = i.isMergeableObject || e;
      var s = Array.isArray(n),
          l = Array.isArray(t),
          d = s === l;
      return d ? s ? i.arrayMerge(t, n, i) : a(t, n, i) : o(n, i);
    }

    return n.all = function (e, t) {
      if (!Array.isArray(e)) throw new Error("first argument should be an array");
      return e.reduce(function (e, o) {
        return n(e, o, t);
      }, {});
    }, n;
  }();
}),
    c = {
  "checkbox.option": "Send url with feedback",
  close: "close",
  "error.archived": "Channel is Archived!",
  "error.badrequest": "Bad Request!",
  "error.forbidden": "Forbidden!",
  "error.internal": "Server Error!",
  "error.notfound": "Channel Not Found!",
  "error.unexpected": "Unexpected error!",
  "error.upload": "Error uploading image!",
  "feedback.type.improvement": "Improvement",
  "feedback.type.bug": "Bug",
  "feedback.type.feature": "Feature",
  "header.title": "Send Feedback",
  "image.remove": "Remove",
  "label.channel": "Channel",
  "label.message": "Message",
  "label.type": "Feedback Type",
  placeholder: "Your message...",
  "submit.sending": "Sending feedback...",
  "submit.sent": "Sent!",
  "submit.text": "Send Feedback",
  "upload.text": "Attach Image",
  "trigger.text": "Send Feedback",
  "footer.text": "React Slack Feedback"
};
var p = t(function (t) {
  return e.createElement("svg", i({
    id: "SlackIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "20",
    height: "20",
    "aria-label": "Slack"
  }, t), e.createElement("path", {
    d: "M21.902.148c-3.299 0-5.973 2.68-5.973 5.985a5.979 5.979 0 0 0 5.973 5.985h5.974V6.133A5.98 5.98 0 0 0 21.902.148m0 15.96H5.973C2.674 16.108 0 18.788 0 22.094c0 3.305 2.674 5.985 5.973 5.985h15.93c3.298 0 5.973-2.68 5.973-5.985 0-3.306-2.675-5.986-5.974-5.986",
    fill: "#36C5F0"
  }), e.createElement("path", {
    d: "M59.734 22.094c0-3.306-2.675-5.986-5.974-5.986-3.299 0-5.973 2.68-5.973 5.986v5.985h5.973a5.98 5.98 0 0 0 5.974-5.985m-15.929 0V6.133A5.98 5.98 0 0 0 37.831.148c-3.299 0-5.973 2.68-5.973 5.985v15.96c0 3.307 2.674 5.987 5.973 5.987a5.98 5.98 0 0 0 5.974-5.985",
    fill: "#2EB67D"
  }), e.createElement("path", {
    d: "M37.831 60a5.98 5.98 0 0 0 5.974-5.985 5.98 5.98 0 0 0-5.974-5.985h-5.973v5.985c0 3.305 2.674 5.985 5.973 5.985m0-15.96h15.93c3.298 0 5.973-2.68 5.973-5.986a5.98 5.98 0 0 0-5.974-5.985H37.831c-3.299 0-5.973 2.68-5.973 5.985a5.979 5.979 0 0 0 5.973 5.985",
    fill: "#ECB22E"
  }), e.createElement("path", {
    d: "M0 38.054a5.979 5.979 0 0 0 5.973 5.985 5.98 5.98 0 0 0 5.974-5.985v-5.985H5.973C2.674 32.069 0 34.749 0 38.054m15.929 0v15.96c0 3.306 2.674 5.986 5.973 5.986a5.98 5.98 0 0 0 5.974-5.985V38.054a5.979 5.979 0 0 0-5.974-5.985c-3.299 0-5.973 2.68-5.973 5.985",
    fill: "#E01E5A"
  }));
}).withConfig({
  displayName: "slack-icon",
  componentId: "w4rng8-0"
})(["margin-right:8px;"]);

var h = function h(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var o = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return o ? "rgba(".concat(parseInt(o[1], 16), ", ").concat(parseInt(o[2], 16), ", ").concat(parseInt(o[3], 16), ", ").concat(isNaN(parseInt(t, 10)) ? 1 : t, ")") : "inherit";
},
    u = function u(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "inherit";
  return function () {
    var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e, t, o) {
      return (e || "object" == typeof e) && t.split(".").reduce(function (e, t) {
        return e && e[t] ? e[t] : null;
      }, e) || o;
    }(o.theme, e, t);
  };
},
    g = o(["box-shadow:none;color:inherit;margin:inherit;padding:inherit;"]),
    m = o(["", ";box-sizing:border-box;"], g),
    b = o(["animation:", " 0.4s ease;animation-fill-mode:both;"], r(["from{opacity:0;transform:translate3d(0,40px,0);}to{opacity:1;transform:none;}"])),
    f = o(["animation:", " 0.4s ease;animation-fill-mode:both;"], r(["from{opacity:1;transform:none;}to{opacity:0;display:none;transform:translate3d(0,10%,0);}"])),
    y = r(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]),
    x = t.div.withConfig({
  displayName: "styles__SlackFeedback",
  componentId: "sc-1ifjbhw-0"
})(["position:fixed;font-family:", ";z-index:99999998;bottom:12px;right:0;margin:1em;text-align:left;font-weight:", ";*{box-sizing:border-box;}textarea{min-height:150px;}"], u("fontFamily", "inherit"), u("content.fontWeight", 400)),
    w = t.div.withConfig({
  displayName: "styles__Loader",
  componentId: "sc-1ifjbhw-1"
})(["margin:50px auto;font-size:10px;position:relative;text-indent:-9999em;border-top:", " solid rgba(255,255,255,0.2);border-right:", " solid rgba(255,255,255,0.2);border-bottom:", " solid rgba(255,255,255,0.2);border-left:", " solid ", ";transform:translateZ(0);animation:", " 0.5s infinite linear;border-radius:50%;width:", ";height:", ";&:after{border-radius:50%;width:", ";height:", ";}"], u("loader.width"), u("loader.width"), u("loader.width"), u("loader.width"), u("loader.color"), y, u("loader.size"), u("loader.size"), u("loader.width"), u("loader.size")),
    v = t.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1ifjbhw-2"
})(["display:none;background:", ";position:relative;z-index:999999999;border-radius:4px;width:", ";bottom:", ";right:0;box-shadow:", ";", ";&.active{", ";display:block;}"], u("colors.background"), u("content.width", "360px"), u("content.bottom", "65px"), u("content.boxShadow"), f, b),
    k = t.div.withConfig({
  displayName: "styles__CloseButton",
  componentId: "sc-1ifjbhw-3"
})(["cursor:pointer;font-weight:", ";opacity:", ";color:", ";margin-left:auto;font-size:11px;&:hover{opacity:", ";color:", ";}"], u("closeButton.fontWeight", "normal"), u("closeButton.opacity", .7), u("closeButton.color", "white"), u("closeButton.hoverOpacity", 1), u("closeButton.hoverColor", "inherit")),
    S = t.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1ifjbhw-4"
})(["display:flex;color:", ";background:", ";padding:0.75em 1em;font-weight:", ";border-radius:3px 3px 0 0;font-size:", ";align-items:center;> img{margin-right:0.5em;}"], u("header.color"), u("colors.secondary"), u("header.fontWeight", "normal"), u("header.fontSize", "14px")),
    C = t.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1ifjbhw-5"
})(["padding:", ";"], u("content.padding")),
    I = (t.div.withConfig({
  displayName: "styles__Icon",
  componentId: "sc-1ifjbhw-6"
})(["margin-right:0.5em;"]), t.div.withConfig({
  displayName: "styles__Trigger",
  componentId: "sc-1ifjbhw-7"
})(["display:flex;align-items:center;position:absolute;right:0;bottom:0;align-items:center;font-weight:", ";background:", ";color:", ";border:", ";white-space:nowrap;padding:", ";border-radius:", ";cursor:pointer;font-size:", ";box-shadow:", ";transition:box-shadow 0.3s,transform 0.2s ease-in,color 0.2s;&:hover{box-shadow:", ";background-color:", ";transform:translateY(-1px);color:", ";border-color:", ";}img{margin-right:8px;}"], u("trigger.fontWeight", "normal"), u("trigger.backgroundColor"), u("trigger.color"), u("trigger.border"), u("trigger.padding"), u("trigger.borderRadius"), u("trigger.fontSize"), u("trigger.boxShadow"), u("trigger.hoverBoxShadow"), u("trigger.hoverBackgroundColor", "inherit"), u("trigger.hoverColor"), u("colors.border"))),
    E = t.ul.withConfig({
  displayName: "styles__Tabs",
  componentId: "sc-1ifjbhw-8"
})(["display:flex;list-style:none;padding:0;margin:0;margin-bottom:0.85em;> li{flex:1 0 calc(100% / 3);user-select:none;background:", ";color:", ";text-align:center;padding:", ";font-size:13px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border:", ";&.selected{border-color:", ";background:", ";color:white;position:relative;}&:hover:not(.selected){border:", ";}&:first-of-type{border-radius:4px 0 0 4px;margin-right:-1px;}&:last-of-type{border-radius:0 4px 4px 0;margin-left:-1px;}}"], u("tab.backgroundColor"), u("tab.color"), u("tab.padding", "0.75em"), u("tab.border"), u("colors.primary"), u("colors.primary"), u("tab.border")),
    j = t.div.withConfig({
  displayName: "styles__ImageUpload",
  componentId: "sc-1ifjbhw-9"
})(["> input{display:none;}"]),
    _ = t.label.withConfig({
  displayName: "styles__UploadButton",
  componentId: "sc-1ifjbhw-10"
})(["color:", ";background:", ";border:", ";padding:0.75em 3em;text-align:center;font-size:", ";margin:auto;margin-bottom:1em;width:100%;display:table;cursor:pointer;border-radius:4px;&:hover{background:", ";color:", ";}"], u("uploadButton.color"), u("uploadButton.backgroundColor"), u("uploadButton.border"), u("uploadButton.fontSize", "13px"), u("uploadButton.hoverBackgroundColor"), u("uploadButton.hoverColor")),
    z = t.label.withConfig({
  displayName: "styles__Label",
  componentId: "sc-1ifjbhw-11"
})(["color:", ";display:block;font-size:", ";margin:5px 0;"], u("colors.primary"), u("label.fontSize")),
    B = t.input.withConfig({
  displayName: "styles__FormElement",
  componentId: "sc-1ifjbhw-12"
})(["", ";width:100%;color:", ";border:", ";border-radius:", ";padding:", ";font-size:", ";background:", ";margin-bottom:0.75em;outline:none;resize:none;&:focus{border:1px solid ", ";box-shadow:", ";}&[disabled],&.disabled{background:", ";pointer-events:none;color:", ";}"], m, u("input.color", "#000000"), u("input.border", "none"), u("input.borderRadius", "3px"), u("input.padding", 0), u("input.fontSize", "14px"), u("input.backgroundColor", "#ffffff"), u("colors.primary"), u("input.boxShadow", "none"), u("input.backgroundColor", "#ffffff"), u("input.color")),
    N = t.button.withConfig({
  displayName: "styles__SubmitButton",
  componentId: "sc-1ifjbhw-13"
})(["display:block;width:100%;padding:", ";text-align:center;background:", ";color:", ";font-weight:", ";outline:none;border:none;font-size:", ";text-transform:", ";letter-spacing:0.5px;border-radius:4px;cursor:pointer;transition:background 0.2s,box-shadow 0.2s;&[disabled],&.disabled{pointer-events:none;opacity:", ";}&.sent{background:", ";pointer-events:none;opacity:1;}&.error{background:", ";pointer-events:none;opacity:1;}&:hover{background:", ";box-shadow:none;}"], u("button.padding", "1em 0.75em"), u("colors.primary"), u("button.color", "white"), u("button.fontWeight", 400), u("button.fontSize", "11px"), u("button.textTransform", "uppercase"), u("button.opacity"), u("colors.success"), u("colors.error"), u("colors.primary")),
    T = t.div.withConfig({
  displayName: "styles__PreviewOverlay",
  componentId: "sc-1ifjbhw-14"
})(["position:absolute;top:0;right:0;bottom:0;left:0;text-align:center;background:", ";opacity:0;&:hover{opacity:1;}span{position:absolute;top:50%;left:50%;z-index:2;transform:translate(-50%,-50%);padding:1em 3em;font-size:12px;text-transform:uppercase;color:#ffffff;border-radius:4px;cursor:pointer;background:", ";transition:background 0.15s;&:hover{background:", ";}}"], u("overlay.backgroundColor"), u("overlay.backgroundColor"), u("colors.secondary")),
    F = t.div.withConfig({
  displayName: "styles__ImagePreview",
  componentId: "sc-1ifjbhw-15"
})(["display:flex;background-size:cover;background-position:center center;position:relative;width:100%;height:", ";border-radius:", ";margin-bottom:0.5em;border:", ";"], u("image.height"), u("image.borderRadius", "4px"), u("image.border"));

t.div.withConfig({
  displayName: "styles__Select",
  componentId: "sc-1ifjbhw-16"
})(["margin-bottom:0.5em;"]);
var O = {
  fontFamily: '-apple-system, BlinkMacSystemFont, Arial, Arial Unicode, "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif',
  colors: {
    border: "#d0d8e1",
    primary: "#0088ff",
    secondary: "#222c4f",
    background: "#f4f4f7",
    success: "#3dc86f",
    error: "#ec3c3c",
    text: "#333333"
  },
  content: {
    width: "380px",
    padding: "0.6em",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 500,
    boxShadow: "0 6px 30px 2px ".concat(h("#222c4f", .3))
  },
  header: {
    color: "white",
    fontWeight: 400,
    backgroundColor: "#222c4f"
  },
  loader: {
    color: "#ffffff",
    size: "4em",
    width: "3px"
  },
  button: {
    fontWeight: 500,
    boxShadow: "0 2px 8px 2px ".concat(h("#0087ff", .2)),
    opacity: .8
  },
  trigger: {
    color: "#ffffff",
    hoverColor: "#ffffff",
    backgroundColor: "#222c4f",
    border: "none",
    padding: "12px 1.25em",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "400",
    boxShadow: "0 3px 12px 1px rgba(34, 44, 79, 0.1)",
    hoverBoxShadow: "0 6px 16px 2px rgba(0, 0, 0, 0.2)",
    hoverBackgroundColor: "inherit"
  },
  input: {
    backgroundColor: "white",
    padding: "0.5em",
    color: "#444444",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #d0d8e1",
    boxShadow: "0 0 8px ".concat(h("#0087ff", .3))
  },
  label: {
    color: "#222c4f",
    fontSize: "12px"
  },
  tab: {
    color: "#333333",
    selectedColor: "white",
    selectedBackgroundColor: "#0087ff",
    border: "1px solid #d0d8e1",
    borderRadius: "4px",
    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  image: {
    height: "140px",
    borderRadius: "4px",
    border: "1px solid #d0d8e1"
  },
  uploadButton: {
    color: "#333333",
    hoverColor: "#333333",
    backgroundColor: "white",
    hoverBackgroundColor: "rgba(255, 255, 255, 0.6)",
    border: "1px solid #d0d8e1"
  },
  overlay: {
    backgroundColor: h("#222c4f", .4)
  }
};
var A = "bug",
    R = "improvement",
    U = "feature";

var M =
/*#__PURE__*/
function (_e$Component) {
  _inherits(M, _e$Component);

  function M(t) {
    var _this;

    _classCallCheck(this, M);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(M).call(this, t)), n(_assertThisInitialized(_assertThisInitialized(_this)), "translate", function (e) {
      var t = _this.props.translations;
      return "object" == typeof t && e in t ? t[e] : c[e] || "";
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
      return function (t) {
        return _this.setState(_defineProperty({}, e, t.target.value));
      };
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "toggle", function () {
      _this.state.open ? _this.close() : _this.activate();
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "activate", function () {
      _this.setState(function (_ref) {
        var e = _ref.open;
        return {
          open: !e
        };
      }, _this.props.onOpen), document.addEventListener("click", _this.handleClickOutside);
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOutside", function (e) {
      e.defaultPrevented || _this.SlackFeedback && _this.SlackFeedback.current && !_this.SlackFeedback.current.contains(e.target) && _this.close();
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "close", function () {
      _this.setState({
        open: !1
      }, function () {
        _this.props.onClose();
      }), document.removeEventListener("click", _this.handleClickOutside);
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "selectType", function (e) {
      return function () {
        return _this.setState({
          selectedType: e
        });
      };
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "resetSentState", function () {
      _this.setState({
        message: ""
      }, function () {
        setTimeout(function () {
          _this.setState({
            sent: !1
          });
        }, _this.props.sentTimeout);
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmitSuccess", function () {
      _this.setState({
        sending: !1,
        sent: !0,
        image: {},
        error: !1
      }, function () {
        return _this.resetSentState();
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmitError", function (e) {
      return _this.setState({
        sending: !1,
        error: _this.determineErrorType(e)
      }, function () {
        setTimeout(function () {
          _this.setState({
            error: null
          });
        }, _this.props.errorTimeout);
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "determineErrorType", function (e) {
      if (!e) return _this.translate("error.unexpected");
      if ("string" == typeof e) return e;

      switch (e.status) {
        case 400:
          return _this.translate("error.badrequest");

        case 403:
          return _this.translate("error.forbidden");

        case 404:
          return _this.translate("error.notfound");

        case 410:
          return _this.translate("error.archived");

        case 500:
          return _this.translate("error.internal");

        default:
          return _this.translate("error.unexpected");
      }
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "send", function () {
      var _this$state = _this.state,
          e = _this$state.selectedType,
          t = _this$state.image;
      var o = "warning";

      switch (_this.setState({
        sending: !0
      }), e) {
        case A:
          o = "danger";
          break;

        case U:
          o = "good";
          break;

        case R:
        default:
          o = "warning";
      }

      var r = {
        attachments: [{
          fallback: "Feedback (".concat(e, ")"),
          author_name: _this.props.user,
          color: o,
          title: e,
          title_link: document.location.href,
          text: _this.state.message,
          footer: _this.translate("footer.text")
        }]
      };
      t.url && (r.attachments[0].image_url = t.url), _this.props.onSubmit(r, _this.onSubmitSuccess.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.onSubmitError.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "attachImage", function (e) {
      var t = e.target.files,
          o = t[0];
      o.preview = window.URL.createObjectURL(o), _this.setState({
        image: o,
        uploadingImage: !0
      }, function () {
        _this.props.onImageUpload(o, _this.onImageUploadSuccess.bind(_assertThisInitialized(_assertThisInitialized(_this))), _this.onImageUploadError.bind(_assertThisInitialized(_assertThisInitialized(_this))));
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "onImageUploadError", function (e) {
      var t = _this.translate("error.upload");

      e && "string" == typeof e && (t = e), _this.setState({
        uploadingImage: !1,
        error: t
      }, function () {
        _this.removeImage(), setTimeout(function () {
          _this.setState({
            error: null
          });
        }, _this.props.errorTimeout);
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "onImageUploadSuccess", function (e) {
      if ("string" != typeof e) return console.error("[SlackFeedback] `url` argument in `imageUploaded` method must be a string"), void _this.removeImage();

      _this.setState(function (_ref2) {
        var t = _ref2.image;
        return {
          uploadingImage: !1,
          image: _objectSpread({}, t, {
            url: e
          })
        };
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "renderImageUpload", function () {
      return _this.state.image.preview ? _this.renderImagePreview() : e.createElement(j, null, e.createElement(_, {
        htmlFor: "imageUpload"
      }, _this.translate("upload.text")), e.createElement(B, {
        as: "input",
        type: "file",
        id: "imageUpload",
        accept: "image/*",
        onChange: function onChange(e) {
          return _this.attachImage(e);
        }
      }));
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "removeImage", function (e) {
      e && e.preventDefault(), _this.setState({
        image: {},
        uploadingImage: !1
      });
    }), n(_assertThisInitialized(_assertThisInitialized(_this)), "renderImagePreview", function () {
      var _this$state2 = _this.state,
          _this$state2$image = _this$state2.image,
          t = _this$state2$image === void 0 ? {} : _this$state2$image,
          o = _this$state2.uploadingImage;
      return t.preview ? e.createElement(F, {
        style: {
          backgroundImage: "url(".concat(t.preview, ")")
        }
      }, o ? e.createElement(w, null) : e.createElement(T, null, e.createElement("span", {
        onClick: _this.removeImage
      }, _this.translate("image.remove")))) : null;
    }), _this.state = {
      open: t.open,
      sending: !1,
      sent: !1,
      error: !1,
      uploadingImage: !1,
      selectedType: t.defaultSelectedType || _this.props.feedbackTypes[0].value,
      image: {},
      message: ""
    }, _this.SlackFeedback = e.createRef();
    return _this;
  }

  _createClass(M, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.disabled) return null;
      var _this$state3 = this.state,
          t = _this$state3.open,
          o = _this$state3.sending,
          r = _this$state3.sent,
          n = _this$state3.error,
          i = _this$state3.selectedType,
          s = _this$state3.uploadingImage,
          c = this.props.channel,
          p = this.props.icon,
          h = Boolean(c) && this.props.showChannel;
      var u = this.translate("submit.text");
      r && (u = this.translate("submit.sent")), o && !r && (u = this.translate("submit.sending")), n && (u = n);
      var g = d(O, this.props.theme);
      return e.createElement(a, {
        theme: g
      }, e.createElement(x, {
        ref: this.SlackFeedback,
        className: l({
          active: t
        })
      }, e.createElement(v, {
        className: l("fadeInUp", {
          active: t
        })
      }, e.createElement(S, null, this.props.showIcon ? e.createElement(p, null) : null, " ", this.translate("header.title"), e.createElement(k, {
        className: "close",
        onClick: this.close
      }, this.translate("close"))), e.createElement(C, null, h && e.createElement("span", {
        id: "channel"
      }, e.createElement(z, {
        htmlFor: "channel"
      }, this.translate("label.channel")), e.createElement(B, {
        disabled: !0,
        as: "input",
        value: this.props.channel
      })), e.createElement(z, null, this.translate("label.type")), e.createElement(E, null, this.props.feedbackTypes.map(function (t) {
        return e.createElement("li", {
          key: t.value,
          className: l({
            selected: i === t.value
          }),
          title: t.label,
          onClick: _this2.selectType(t.value)
        }, t.label);
      })), e.createElement(z, null, this.translate("label.message")), e.createElement(B, {
        as: "textarea",
        name: "message",
        value: this.state.message,
        placeholder: this.translate("placeholder"),
        onChange: this.handleChange("message")
      }), this.props.onImageUpload ? this.renderImageUpload() : null, e.createElement(N, {
        disabled: o || s || !this.state.message,
        className: l({
          sent: r,
          error: n
        }),
        onClick: this.send
      }, u))), e.createElement(I, {
        className: l({
          active: t
        }),
        onClick: this.toggle
      }, this.props.showIcon ? e.createElement(p, null) : null, " ", this.translate("trigger.text"))));
    }
  }]);

  return M;
}(e.Component);

M.defaultProps = {
  channel: "",
  defaultSelectedType: null,
  disabled: !1,
  errorTimeout: 8e3,
  feedbackTypes: [{
    value: A,
    label: c["feedback.type.bug"]
  }, {
    value: R,
    label: c["feedback.type.improvement"]
  }, {
    value: U,
    label: c["feedback.type.feature"]
  }],
  icon: function icon() {
    return e.createElement(p, null);
  },
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  open: !1,
  sentTimeout: 5e3,
  showChannel: !0,
  showIcon: !0,
  theme: O,
  translations: c,
  user: "Anonymous"
}, M.defaultTheme = O, M.SlackIcon = p;
var $ = Object.freeze({
  dark: {
    colors: {
      primary: "#3579f5",
      secondary: "black",
      background: "black"
    },
    content: {
      padding: "0 0.75em 1em",
      width: "400px"
    },
    trigger: {
      color: "white",
      hoverColor: "white",
      backgroundColor: "black",
      border: "none",
      padding: "14px 1.25em",
      borderRadius: "6px",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      padding: "1em",
      color: "white",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none"
    },
    label: {
      fontSize: "12px"
    },
    tab: {
      color: "rgba(255, 255, 255, 0.8)",
      border: "none",
      borderRadius: "4px",
      padding: "1em",
      backgroundColor: "rgba(255, 255, 255, 0.15)"
    },
    uploadButton: {
      color: "white",
      hoverColor: "white",
      border: "none",
      hoverBorder: "none",
      backgroundColor: "#222",
      hoverBackgroundColor: "#323232"
    },
    image: {
      border: "none"
    }
  }
});
export default M;
export { $ as themes };